import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';

const ActionButtonsGroup = ({ buttons }) => (
  <ButtonGroup>
    {buttons.map(({ icon, name, id, func, text, variant, className }) => (
      <Button key={id} id={id} name={name} onClick={func} className={className} variant={variant || 'primary'}>
        {icon && <i className="material-icons">{icon}</i>} 
        {text}
      </Button>
    ))}
  </ButtonGroup>
);

export default ActionButtonsGroup;
